/**
 * HTML template for the airport info view and clock.
 *
 * @property AIRPORT_INFO_TEMPLATE
 * @type {String|HTML Element}
 * @final
 */
export const AIRPORT_INFO_TEMPLATE = '' +
'<div id="airportInfo" class="notSelectable">' +
'    <div class="airportInfo-header js-airportInfo-header"></div>' +
'    <div class="airportInfo-line airportInfo-line_primary">' +
'        <div class="airportInfo-label">RWY</div>' +
'        <div class="airportInfo-value js-airportInfo-runway-value"></div>' +
'        <div class="airportInfo-divider"></div>' +
'        <div class="airportInfo-label">WIND</div>' +
'        <div class="airportInfo-value js-airportInfo-wind-value"></div>' +
'    </div>' +
'    <div class="airportInfo-line">' +
'        <div class="airportInfo-label">QNH</div>' +
'        <div class="airportInfo-value js-airportInfo-altimeter-value"></div>' +
'        <div class="airportInfo-divider"></div>' +
'        <div class="airportInfo-label">ELEV</div>' +
'        <div class="airportInfo-value js-airportInfo-elevation-value"></div>' +
'    </div>' +
'</div>';
